import { render, staticRenderFns } from "./business-order-logistics.vue?vue&type=template&id=004db510"
import script from "./business-order-logistics.vue?vue&type=script&lang=ts"
export * from "./business-order-logistics.vue?vue&type=script&lang=ts"
import style0 from "./business-order-logistics.vue?vue&type=style&index=0&id=004db510&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports